import { Search } from '@mui/icons-material'
import {
  Box,
  Card,
  Divider,
  FormHelperText,
  FormLabel,
  InputBase,
  Stack,
  Theme,
} from '@mui/material'
import { ChangeEvent, CSSProperties, useState } from 'react'
import { FieldError } from 'react-hook-form'

import { inputWidth } from 'providers/material-ui/theme/constants'
import { FilterableListBoxContext } from './context/FilterableListBoxContext'
import { FilteredListBoxRootProps } from './types'

export const FilterableListBox = ({
  children,
  disabled,
  error,
  label,
  placeholder,
  width,
}: FilteredListBoxRootProps): React.JSX.Element => {
  const [filter, setFilter] = useState<string>('')

  const calculatedWidth: number | string = inputWidth[width ?? 'lg']

  const ErrorSection = ({ error }: { error: FieldError }): React.JSX.Element => (
    <>
      <Divider />
      <FormHelperText
        sx={{
          color: (theme: Theme): CSSProperties['color'] => theme.palette.error.main,
          p: 2,
        }}
      >
        {error?.message}
      </FormHelperText>
    </>
  )

  return (
    <Stack spacing={1}>
      <FormLabel>{label}</FormLabel>

      <Box sx={{ width: calculatedWidth }}>
        <Card
          sx={{
            border: (theme: Theme): CSSProperties['border'] =>
              `1px solid ${error ? theme.palette.error.main : theme.palette.grey[400]}`,
          }}
        >
          <InputBase
            data-cy='list-box-filter'
            disabled={disabled}
            endAdornment={<Search data-cy='search-icon' />}
            fullWidth
            onChange={(event: ChangeEvent<HTMLInputElement>): void => setFilter(event.target.value)}
            placeholder={placeholder}
            sx={{ p: 2 }}
            value={filter}
          />

          <Divider />

          <FilterableListBoxContext.Provider value={{ filter }}>
            {children}
          </FilterableListBoxContext.Provider>

          {error && ErrorSection({ error })}
        </Card>
      </Box>
    </Stack>
  )
}
